module.exports = __webpack_public_path__ + "img/reducir.68fb49e8.svg";